import React, { useMemo } from 'react'

import { useCurrentUser } from '../../../hooks/useCurrentUser'
import { canManageVolunteers } from '../../../lib/event'
import CheckInOutButton from './CheckInOutButton'
import FollowButton from './FollowButton'
import VolunteerInfo from './VolunteerInfo'
import styles from './volunteerList.module.scss'

export default function VolunteerRow({
  volunteer,
  event,
  isOrganizer,
  isAdmin,
  isTaskLeader,
  onUpdate,
  showCheckInButton = true,
}) {
  const { currentUser } = useCurrentUser()

  const canManage = useMemo(
    () => canManageVolunteers(event, currentUser),
    [event, currentUser],
  )

  const isCurrentUser = useMemo(
    () => currentUser?.id === volunteer.user?.id,
    [currentUser?.id, volunteer.user?.id],
  )

  const isTeamMember = useMemo(
    () =>
      isOrganizer ||
      isAdmin ||
      isTaskLeader ||
      volunteer.user?.id === event?.user?.id ||
      event?.admins?.some(a => a.id === volunteer.user?.id),
    [
      isOrganizer,
      isAdmin,
      isTaskLeader,
      volunteer.user?.id,
      event?.user?.id,
      event?.admins,
    ],
  )

  if (!volunteer || !volunteer.user) {
    return null
  }

  return (
    <div className={styles.volunteerRow}>
      <VolunteerInfo volunteer={volunteer} isTaskLeader={isTaskLeader} />
      <div className={styles.volunteerActions}>
        {/* Managers can interact; volunteers can see their own status (view-only). */}
        {showCheckInButton && (canManage || isCurrentUser) && (
          <CheckInOutButton
            volunteer={volunteer}
            event={event}
            canManage={canManage}
            onUpdate={onUpdate}
          />
        )}
        <FollowButton
          volunteer={volunteer}
          isCurrentUser={isCurrentUser}
          onUpdate={onUpdate}
        />
      </div>
    </div>
  )
}
